import { useState } from 'react';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import Input from '../../../../Core/Fields/Floating/Input';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';

const Tab1 = ({po,grnData,activityboll}) => {
   const [showActivity, setShowActivity] = useState(true);
  return (
    <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px",flexWrap:'nowrap', borderRadius: "5px", height: '72vh', overflowY: 'scroll' }} >
      <div className="col-12 mt-1">
         <div className="row mb-2">

      <div className="col-md-6">
        <Input id="orderNo" label="No." readOnly value={grnData?.name} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6">
        <Input id="orderdatepo" type="text" readOnly style={{ height: '30px',backgroundColor:'#f8f6f6' }} label="Date" value={po.currentdate}  />
      </div>
         </div>
      </div>
     

     <div className="col-12 ">
         <div className="row mb-2">
             <div className="col-6">
         <Input id="po" label="PO No." readOnly value={grnData?.purchase_order_no}   style={{ height: '30px' }} />
      </div>
      <div className="col-6">
         <Input id="grnno" label="GRN No." readOnly value={grnData.against_purchase_receipt} style={{ height: '30px' }} />
      </div>

            </div>
         </div>
     
      <div className="col-12 mb-2" >
         <Input id="vandortitle" label="Supplier" readOnly value={grnData.supplier_name}   style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2" >
         <Input id="vandortitle" label="Source Bin" readOnly value={grnData.items?.[0]?.s_warehouse}   style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2" >
         <Input id="vandortitle" label="Post Date" readOnly value={grnData.posting_date}   style={{ height: '30px' }} />

      </div>
      <div className="col-12 ">
         <Input id="vandortitle" label="Post Time" readOnly value={grnData?.posting_time?.split('.')[0]}   style={{ height: '30px' }} />
      </div>
      <CollapsibleSection title="Taxes and Charges"></CollapsibleSection>
      <div className='col-12'>
            <div>
               <div className="col-12">
                  <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                     <p className="firstcolor m-0" >
                        Activity
                     </p>
                     <GetIcon
                        iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                        size={22}
                     />
                  </div>
                  {showActivity && (
                     <VersionHistory doctype="Stock Entry" docname={grnData?.name} activityboll={activityboll} />

                  )}
               </div>
            </div>
         </div>
    </div>
  )
}

export default Tab1